import { Component } from "@angular/core";

@Component({
  selector: 'auth-component',
  templateUrl: './auth.component.html'
})

export class AuthComponent {}